/* ============================================================================
   facil. — Onglets section éducation PDP (<facil-edu-tabs>)
   ----------------------------------------------------------------------------
   Vanilla, zéro dépendance. ARIA (aria-selected / tabindex roving), navigation
   clavier (flèches, Home/End), fondu géré en CSS (.is-in). État initial = HTML.
   ============================================================================ */
(function () {
  'use strict';

  class FacilEduTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = this.tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i, false));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });
    }

    select(index, focus) {
      this.tabs.forEach((tab, j) => {
        const active = index === j;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        const panel = this.panels[j];
        if (!panel) return;
        if (active) {
          panel.hidden = false;
          panel.classList.remove('is-in');
          void panel.offsetWidth; /* reflow → relance le fondu */
          panel.classList.add('is-in');
        } else {
          panel.hidden = true;
          panel.classList.remove('is-in');
        }
      });
      if (focus && this.tabs[index]) this.tabs[index].focus();
    }

    onKey(e, i) {
      const last = this.tabs.length - 1;
      let n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = i === 0 ? last : i - 1;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = last;
      else return;
      e.preventDefault();
      this.select(n, true);
    }
  }

  if (!customElements.get('facil-edu-tabs')) {
    customElements.define('facil-edu-tabs', FacilEduTabs);
  }
})();

/* ============================================================================
   Fade-up au scroll des sections PDP sous le hero (technologie + FAQ), façon home.
   Scopé PDP (ce JS n'est chargé que par la fiche produit). On ne touche PAS la
   section éducation (barre sticky → un transform casserait le sticky). Sans JS ou
   en reduced-motion : tout reste visible (l'état caché n'est posé que par le JS).
   ============================================================================ */
(function () {
  'use strict';
  if (window.__facilPdpReveal) return; /* facil-pdp-edu.js peut être chargé par edu ET faq */
  window.__facilPdpReveal = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.alto-tech, .facil-faq');
  if (!els.length || reduce || !('IntersectionObserver' in window)) return;

  els.forEach(function (el) {
    el.classList.add('facil-up'); /* état caché initial (CSS) */
    void el.offsetHeight;          /* reflow : commit avant la révélation */
  });

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('facil-up--in');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  els.forEach(function (el) { io.observe(el); });
})();

/* ============================================================================
   Filtre FAQ par catégorie (<facil-faq-filter>) · vanilla, aria-pressed, clavier.
   Une chip active à la fois → n'affiche que les accordéons [data-faq-item] de cette
   catégorie. Léger fondu des items à chaque changement (pas de saut brutal).
   ============================================================================ */
(function () {
  'use strict';
  class FacilFaqFilter extends HTMLElement {
    connectedCallback() {
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-faq-chip]'));
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-faq-item]'));
      if (!this.chips.length) return;
      this.chips.forEach((chip, i) => {
        chip.addEventListener('click', () => this.apply(i, false));
        chip.addEventListener('keydown', (e) => this.onKey(e, i));
      });
      let start = 0;
      this.chips.forEach((c, i) => { if (c.getAttribute('aria-pressed') === 'true') start = i; });
      this.apply(start, true);
    }
    apply(idx, initial) {
      const cat = this.chips[idx].getAttribute('data-faq-chip');
      this.chips.forEach((c, i) => c.setAttribute('aria-pressed', i === idx ? 'true' : 'false'));
      this.items.forEach((it) => {
        const match = it.getAttribute('data-faq-item') === cat;
        it.hidden = !match;
        if (match && !initial) {
          it.classList.remove('faq-in');
          void it.offsetWidth; /* reflow → relance le fondu */
          it.classList.add('faq-in');
        }
      });
    }
    onKey(e, i) {
      const last = this.chips.length - 1;
      let n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = i === 0 ? last : i - 1;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = last;
      else return;
      e.preventDefault();
      this.chips[n].focus();
      this.apply(n, false);
    }
  }
  if (!customElements.get('facil-faq-filter')) {
    customElements.define('facil-faq-filter', FacilFaqFilter);
  }
})();

/* ============================================================================
   UGC PDP — vidéos LAZY : la source n'est chargée et lue qu'à l'entrée de la tuile
   dans le viewport (autoplay muet, boucle, playsinline) ; pause à la sortie.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__facilUgcVid) return;
  window.__facilUgcVid = true;
  var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-ugc-video]'));
  if (!vids.length) return;

  function load(v) {
    if (v.dataset.ugcLoaded) return;
    v.dataset.ugcLoaded = '1';
    Array.prototype.slice.call(v.querySelectorAll('source[data-src]')).forEach(function (src) {
      src.src = src.getAttribute('data-src');
    });
    v.load();
  }

  if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          load(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    },
    { threshold: 0.25 }
  );
  vids.forEach(function (v) { io.observe(v); });
})();

/* ============================================================================
   UGC carousel (<facil-ugc-carousel>) — flèches ‹ › qui scrollent le track par ~2
   tuiles (smooth). Masque prev au début / next à la fin. Mobile : flèches cachées en CSS.
   ============================================================================ */
(function () {
  'use strict';
  class FacilUgcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.facil-ugc__track');
      this.prev = this.querySelector('[data-ugc-prev]');
      this.next = this.querySelector('[data-ugc-next]');
      if (!this.track) return;
      if (this.prev) this.prev.addEventListener('click', () => this.scrollTiles(-2));
      if (this.next) this.next.addEventListener('click', () => this.scrollTiles(2));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }
    step() {
      const cell = this.track.querySelector('.facil-ugc__cell');
      return cell ? cell.getBoundingClientRect().width + 16 : 280; /* tuile + gap 1rem */
    }
    scrollTiles(n) {
      this.track.scrollBy({ left: n * this.step(), behavior: 'smooth' });
    }
    update() {
      const t = this.track;
      if (this.prev) this.prev.hidden = t.scrollLeft <= 1;
      if (this.next) this.next.hidden = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
    }
  }
  if (!customElements.get('facil-ugc-carousel')) {
    customElements.define('facil-ugc-carousel', FacilUgcCarousel);
  }
})();

/* ============================================================================
   Avis Judge.me — bascule état vide facil (0 avis) ↔ widget restylé (≥1 avis) :
   on garde .facil-reviews--empty tant qu'aucune carte .jdgm-rev n'existe. Le bouton
   du bloc vide ([data-facil-write]) forwarde le clic vers le .jdgm-write-rev-link
   natif → ouvre le vrai formulaire Judge.me (handler natif conservé).
   ============================================================================ */
(function () {
  'use strict';
  if (window.__facilReviews) return;
  window.__facilReviews = true;
  var section = document.querySelector('.facil-reviews');
  if (!section) return;
  var widget = section.querySelector('.jdgm-review-widget');

  function refresh() {
    if (!widget) return;
    /* rendu Judge.me présent ET pas d'état « aucun avis » → de vrais avis → on rend la main au widget natif. */
    var hasReviews = widget.querySelector('.jm-review-widget') && !widget.querySelector('.jm-no-reviews-state, .jdgm-empty-state');
    section.classList.toggle('facil-reviews--empty', !hasReviews);
  }
  if (widget && 'MutationObserver' in window) {
    new MutationObserver(refresh).observe(widget, { childList: true, subtree: true });
  }

  /* Judge.me est chargé mais n'a pas peuplé notre widget → on (re)déclenche son rendu. */
  function jmKick() {
    if (!window.jdgm || !widget || widget.children.length) return;
    try {
      if (typeof window.jdgm.initializeWidgets === 'function') window.jdgm.initializeWidgets();
      else if (typeof window.jdgm.batchRenderBadges === 'function') window.jdgm.batchRenderBadges();
    } catch (e) {}
  }
  [300, 900, 2000, 4000].forEach(function (t) { setTimeout(jmKick, t); });

  refresh();
  setTimeout(refresh, 1500);
  setTimeout(refresh, 4000);

  function nativeWriteLink() {
    return section.querySelector('.jm-no-reviews-state__action-buttons button')
        || section.querySelector('.jm-action-buttons__button.jm-button--primary')
        || section.querySelector('.jm-review-widget__header .jm-button--primary')
        || section.querySelector('.jm-button--primary')
        || section.querySelector('.jdgm-write-rev-link');
  }

  section.addEventListener('click', function (e) {
    if (!e.target.closest('[data-facil-write]')) return;
    e.preventDefault();
    /* On NE masque rien : le bloc résumé facil reste visible, on ne fait que déclencher le form natif. */
    var link = nativeWriteLink();
    if (link) {
      link.click();
      setTimeout(function () {
        var form = section.querySelector('.jdgm-form, .jdgm-form-wrapper');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 120);
    }
  });
})();

/* ============================================================================
   Avant/Après (<facil-baf>) — curseur 2 images. Drag souris+tactile (Pointer Events)
   sur tout le cadre + range clavier (flèches). Met à jour --baf-pos (clip de l'après).
   ============================================================================ */
(function () {
  'use strict';
  class FacilBaf extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.range = this.querySelector('.facil-baf__range');
      var dragging = false;
      function pct(clientX) {
        var r = self.getBoundingClientRect();
        return Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      }
      function set(p) {
        self.style.setProperty('--baf-pos', p + '%');
        if (self.range) self.range.value = Math.round(p);
      }
      this.addEventListener('pointerdown', function (e) {
        e.preventDefault(); /* stoppe la sélection/le drag natif de l'image */
        dragging = true;
        if (self.setPointerCapture) { try { self.setPointerCapture(e.pointerId); } catch (err) {} }
        set(pct(e.clientX));
      });
      this.addEventListener('pointermove', function (e) { if (dragging) set(pct(e.clientX)); });
      this.addEventListener('pointerup', function () { dragging = false; });
      this.addEventListener('pointercancel', function () { dragging = false; });
      if (this.range) {
        this.range.addEventListener('input', function () { self.style.setProperty('--baf-pos', self.range.value + '%'); });
      }
      set(this.range ? +this.range.value : 50);
    }
  }
  if (!customElements.get('facil-baf')) customElements.define('facil-baf', FacilBaf);
})();

/* ============================================================================
   Note PDP réelle (Judge.me) + clic → scroll vers les avis (#avis).
   Lit le badge Judge.me (data-pdp-jm-badge) → si nb d'avis > 0, remplit nos
   étoiles (--r = moyenne) + « (N avis) » et révèle la note. Sinon masquée
   (règle facil : pas d'étoiles tant qu'il n'y a pas de vrais avis).
   ============================================================================ */
(function () {
  'use strict';
  if (window.__facilPdpRating) return;
  window.__facilPdpRating = true;

  var rating = document.querySelector('[data-pdp-rating]');
  if (!rating) return;
  var badge = document.querySelector('[data-pdp-jm-badge]');

  rating.addEventListener('click', function (e) {
    e.preventDefault();
    var target = document.querySelector('#avis');
    if (!target) return;
    var header = document.querySelector('.header, .section-header, header.header');
    var off = (header ? header.offsetHeight : 0) + 20;
    var y = target.getBoundingClientRect().top + window.pageYOffset - off;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  function readBadge() {
    if (!badge) return { num: 0, avg: 0 };
    var el = badge.querySelector('[data-number-of-reviews]') || badge.querySelector('[data-average-rating]') || badge.firstElementChild;
    var num = el ? parseInt(el.getAttribute('data-number-of-reviews'), 10) : NaN;
    var avg = el ? parseFloat(el.getAttribute('data-average-rating')) : NaN;
    if (!num || isNaN(num)) { var m = badge.textContent.match(/(\d+)\s*(avis|review)/i); if (m) num = parseInt(m[1], 10); }
    if (!avg || isNaN(avg)) { var a = badge.textContent.match(/([0-5][.,]\d)/); if (a) avg = parseFloat(a[1].replace(',', '.')); }
    return { num: num || 0, avg: avg || 0 };
  }

  function update() {
    var d = readBadge();
    if (d.num > 0) {
      var cnt = rating.querySelector('[data-pdp-rating-count]');
      if (cnt) cnt.textContent = '(' + d.num + ' avis)';
      var stars = rating.querySelector('[data-pdp-stars]');
      if (stars && d.avg) stars.style.setProperty('--r', d.avg);
      rating.hidden = false;
    } else {
      rating.hidden = true;
    }
  }
  update();
  [700, 2000, 4000].forEach(function (t) { setTimeout(update, t); }); // Judge.me peut rendre tard
})();
